import { media, styled } from '@styles';
import crossImg from 'images/cross-x.svg';

export const TagCheckbox = styled.div`
  align-items: center;
  cursor: pointer;
  position: relative;
  margin: 5.5px 3px;
`;

export const LabelInner = styled.span`
  height: 46px;
  font-size: ${(props) => props.theme.typography.h5FontSize};
  line-height: 100%;
  border-radius: 23px;
  box-shadow: inset 0px 0px 0px 2px #eaeaea;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px 6px;
  color: ${(props) => props.theme.colors.baseFont};
  ${media.largeScreen`
    height: 36px;
    padding-bottom: 4px;
  `}
  ${media.smallScreen`
    padding-bottom: 2px;
  `}
  ::after {
    margin-left: 6px;
    content: '';
    display: none;
    width: 14px;
    height: 14px;
    background: url(${crossImg});
    background-size: contain;
    ${media.largeScreen`
      width: 8px;
      height: 8px
    `}
  }
`;

export const Label = styled.label`
  display: flex;
  cursor: pointer;
  justify-content: flex-start;
  align-items: center;
  input[type='checkbox'] {
    display: none;
    position: relative;
    right: -999em;
  }
  div {
    display: flex;
    justify-content: center;
    align-items: center;

    ${TagCheckbox}:hover & {
      ${LabelInner} {
        background: #f9edec;
        box-shadow: none;
      }
    }

    :focus {
      outline: none;
    }
  }

  input:checked + div {
    ${LabelInner} {
      background: #c34c3e;
      box-shadow: none;
      color: #ffffff;
      ::after {
        display: block;
      }
    }

    &:hover {
      ${LabelInner} {
        background: #c9c9c9;
        color: ${(props) => props.theme.colors.baseFont};
      }
    }
  }
`;
